import { render, staticRenderFns } from "./HotJobs.vue?vue&type=template&id=08c6341e&"
import script from "./HotJobs.vue?vue&type=script&lang=js&"
export * from "./HotJobs.vue?vue&type=script&lang=js&"
import style0 from "./HotJobs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports